import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import AdminNavbar from "../Layout/AdminNavbar";
import { FaTrash } from "react-icons/fa";
import API_BASE_URL from "../config";
import "./AdminManageTeam.css";

const AdminManageTeams = () => {
  const [myTeam, setMyTeam] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem("manageTeamFilters");
    return savedFilters
      ? JSON.parse(savedFilters)
      : { teamId: "", projectId: "" };
  });


  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const [formData, setFormData] = useState({
    teamId: "",
    employeeId: "",
    reporterId: "",
    projectId: "",
  });



  // Load data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const axiosConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [teamRes, projRes, myTeamRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/teams`, axiosConfig),
          axios.get(`${API_BASE_URL}/api/projects`, axiosConfig),
          axios.get(`${API_BASE_URL}/api/manageteam`, axiosConfig),
        ]);

        setTeams(teamRes.data);
        setProjects(projRes.data);
        setMyTeam(Array.isArray(myTeamRes.data) ? myTeamRes.data : []);


      } catch (err) {
        console.error(err);
        toast.error("Failed to load data.");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!showForm) return;

    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${API_BASE_URL}/api/employees/active`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setEmployees(res.data);
      } catch (err) {
        toast.error("Failed to load employees.");
      }
    };

    fetchEmployees();
  }, [showForm]);



  useEffect(() => {
    localStorage.setItem("manageTeamFilters", JSON.stringify(filters));
  }, [filters]);



  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleFilterChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });

  // Add team member
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Required field validation
    if (
      !formData.teamId ||
      !formData.projectId ||
      !formData.employeeId ||
      !formData.reporterId
    ) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/api/manageteam`,
        formData,
        config
      );

      setMyTeam(prev => [...prev, response.data]);

      toast.success("Team Member added successfully!");

      setFormData({
        teamId: "",
        employeeId: "",
        reporterId: "",
        projectId: "",
      });

      setShowForm(false);

    } catch (err) {
      toast.error(err.response?.data || "Something went wrong.");
    }
  };




  // Remove team member
  const confirmDelete = async () => {
    if (!selectedMember) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${API_BASE_URL}/api/manageteam/${selectedMember.assignmentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMyTeam(prev =>
        prev.filter(m => m.assignmentId !== selectedMember.assignmentId)
      );

      toast.success(
        `${selectedMember.employeeFirstName} ${selectedMember.employeeLastName} removed successfully`
      );

      setShowDeleteModal(false);
      setSelectedMember(null);

    } catch (err) {
      toast.error("Error removing member.");
    }
  };






  // Fiilters
  let filteredTeam = myTeam.filter((m) => {
    const teamMatch =
      !filters.teamId || Number(m.teamId) === Number(filters.teamId);

    const projectMatch =
      !filters.projectId || m.projectName === filters.projectId;

    return teamMatch && projectMatch;
  });




  // Sorting

  const sortData = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });
  };

  // helper to extract nested values based on key
  const getValue = (m, key) => {
    switch (key) {
      case "employee":
        return m.employeeFirstName ?? "";
      case "team":
        return m.teamName ?? "";
      case "project":
        return m.projectName ?? "";
      case "reporter":
        return m.reporterFirstName ?? "";
      case "id":
        return m.assignmentId ?? "";

      default:
        return "";
    }
  };

  if (sortConfig.key) {
    filteredTeam = [...filteredTeam].sort((a, b) => {
      const valA = getValue(a, sortConfig.key);
      const valB = getValue(b, sortConfig.key);

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  // Arrow icon logic
  const arrow = (key) =>
    sortConfig.key === key ? (sortConfig.direction === "asc" ? " ↑" : " ↓") : " ";




  const closeModal = () => {
    setFormData({
      teamId: "",
      projectId: "",
      employeeId: "",
      reporterId: "",
    });

    setShowForm(false);
  };

  return (
    <div
      className="d-flex flex-column"
      style={{ height: "100vh", overflow: "hidden" }}
    >

      <AdminNavbar />

      <div
        className="container-fluid bg-light flex-grow-1 main-scroll-area">

        <div className="card shadow-none border-0">
          <div
            className="card-header bg-light text-dark d-flex justify-content-between align-items-center"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              background: "#f8f9fa"
            }}
          >
            <h4 className="mb-0">👥 Manage Team</h4>
          </div>


          {/* Add Modal */}
          {showForm && (
            <>
              {/* Backdrop */}
              <div
                className="custom-backdrop"
                onClick={closeModal}
              ></div>

              {/* Modal */}
              <div className="custom-modal-wrapper">
                <div className="custom-modal">

                  <div className="custom-modal-header">
                    <h5>Add Team Member</h5>
                    <button
                      className="btn-close"
                      onClick={() => setShowForm(false)}
                    ></button>
                  </div>

                  <div className="custom-modal-body">
                    <div className="row g-3">

                      <div className="col-md-6">
                        <label className="form-label">
                          Team <span style={{ color: "red" }}>*</span>
                        </label>

                        <select
                          name="teamId"
                          value={formData.teamId}
                          onChange={handleChange}
                          className="form-select"
                          required
                        >
                          <option value="">Select Team</option>
                          {teams.map((t) => (
                            <option key={t.id} value={t.id}>{t.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Project <span style={{ color: "red" }}>*</span>
                        </label>

                        <select
                          name="projectId"
                          value={formData.projectId}
                          onChange={handleChange}
                          className="form-select"
                          required
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Employee <span style={{ color: "red" }}>*</span>
                        </label>

                        <select
                          name="employeeId"
                          value={formData.employeeId}
                          onChange={handleChange}
                          className="form-select"
                          required
                        >
                          <option value="">Select Employee</option>
                          {employees.map((e) => (
                            <option key={e.id} value={e.id}>
                              {e.firstName} {e.lastName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">
                          Reporter <span style={{ color: "red" }}>*</span>
                        </label>

                        <select
                          name="reporterId"
                          value={formData.reporterId}
                          onChange={handleChange}
                          className="form-select"
                          required
                        >
                          <option value="">Select Reporter</option>
                          {employees.map((r) => (
                            <option key={r.id} value={r.id}>
                              {r.firstName} {r.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="custom-modal-footer">
                    <button
                      className="btn btn-primary px-4"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                    <button
                      className="btn btn-light"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>

                </div>
              </div>
            </>
          )}

          {showDeleteModal && selectedMember && (
            <>
              <div className="custom-backdrop" onClick={() => setShowDeleteModal(false)}></div>

              <div className="custom-modal-wrapper">
                <div className="custom-modal" style={{ maxWidth: "500px" }}>

                  <div className="custom-modal-header">
                    <h5 style={{ color: "#dc3545" }}>Confirm Removal</h5>
                    <button
                      className="btn-close"
                      onClick={() => setShowDeleteModal(false)}
                    ></button>
                  </div>

                  <div className="custom-modal-body">
                    <p style={{ marginBottom: "10px" }}>
                      Are you sure you want to remove this member?
                    </p>

                    <div style={{ background: "#f8f9fa", padding: "12px", borderRadius: "6px" }}>
                      <strong>Employee:</strong> {selectedMember.employeeFirstName} {selectedMember.employeeLastName} <br />
                      <strong>Team:</strong> {selectedMember.teamName} <br />
                      <strong>Project:</strong> {selectedMember.projectName} <br />
                      <strong>Manager:</strong> {selectedMember.reporterFirstName} {selectedMember.reporterLastName}
                    </div>
                  </div>

                  <div className="custom-modal-footer">
                    <button
                      className="btn btn-danger px-4"
                      onClick={confirmDelete}
                    >
                      Remove
                    </button>
                    <button
                      className="btn btn-light"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </button>
                  </div>

                </div>
              </div>
            </>
          )}




          {/* Filters */}
          <div className="p-3 border-bottom bg-light sticky-filters">

            <div className="row g-3 align-items-end">

              {/* Team Filter */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">
                  Team
                </label>
                <select
                  name="teamId"
                  value={filters.teamId}
                  onChange={handleFilterChange}
                  className="form-select"
                >
                  <option value="">All Teams</option>
                  {teams
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                </select>
              </div>

              {/* Project Filter */}
              <div className="col-md-3">
                <label className="form-label fw-semibold">
                  Project
                </label>
                <select
                  name="projectId"
                  value={filters.projectId || ""}
                  onChange={handleFilterChange}
                  className="form-select"
                >
                  <option value="">All Projects</option>
                  {projects
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((p) => (
                      <option key={p.id} value={p.name}>
                        {p.name}
                      </option>
                    ))}
                </select>
              </div>

              {/* Add Button */}
              <div className="col-md-6 text-end">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      teamId: filters.teamId || "",
                      projectId: filters.projectId
                        ? projects.find((p) => p.name === filters.projectId)?.id || ""
                        : "",
                    }));
                    setShowForm(true);
                  }}
                >
                  ➕ Add
                </button>
              </div>

            </div>
          </div>




          {/*  Table */}
          <div className="card-body p-0">

            {filteredTeam.length === 0 ? (
              <div className="text-center py-5 text-muted">
                No team members found.
              </div>
            ) : (

              <table className="table align-middle mb-0 sticky-table">

                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#656768",
                    zIndex: 10
                  }}
                >
                  <tr>
                    <th onClick={() => sortData("id")} style={{ cursor: "pointer", background: "#E2E6ED", color: "#111111" }} >
                      Sr {arrow("id")}
                    </th>

                    <th onClick={() => sortData("employee")} style={{ cursor: "pointer", background: "#E2E6ED", color: "#111111" }}>
                      Employee {arrow("employee")}
                    </th>

                    <th onClick={() => sortData("team")} style={{ cursor: "pointer", background: "#E2E6ED", color: "#111111" }}>
                      Team {arrow("team")}
                    </th>

                    <th onClick={() => sortData("project")} style={{ cursor: "pointer", background: "#E2E6ED", color: "#111111" }}>
                      Project {arrow("project")}
                    </th>

                    <th onClick={() => sortData("reporter")} style={{ cursor: "pointer", background: "#E2E6ED", color: "#111111" }}>
                      Manager {arrow("reporter")}
                    </th>

                    <th style={{ background: "#E2E6ED", color: "#111111" }}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredTeam.map((m, idx) => (
                    <tr key={m.assignmentId}>
                      <td>{idx + 1}</td>
                      <td>{m.employeeFirstName} {m.employeeLastName}</td>
                      <td>{m.teamName}</td>
                      <td>{m.projectName}</td>
                      <td>{m.reporterFirstName} {m.reporterLastName}</td>
                      <td>
                        <button
                          onClick={() => {
                            setSelectedMember(m);
                            setShowDeleteModal(true);
                          }}

                          style={{
                            border: "none",
                            background: "transparent",
                            color: "rgb(5, 5, 5)",
                            cursor: "pointer"
                          }}
                        >
                          <FaTrash size={14} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>

            )}

          </div>


        </div>
      </div>
    </div>
  );
};

export default AdminManageTeams;
